<template>
  <div class="album">
    <!-- {{ $route.query.id }} -->
    <div class="go-back fa fa-history" @click="$router.go(-1)">返回</div>

    <!-- 专辑详情 -->
    <template v-if="singAlbum[0]">
      <div class="top">
        <div
          class="bg"
          :style="'backgroundImage:url(' + singAlbum[0].al.picUrl + ')'"
        ></div>
        <div class="fleft">
          <img :src="singAlbum[0].al.picUrl" alt="" />
          <b>专辑</b>
        </div>
        <div class="fright">
          <h5>{{ singAlbum[0].al.name }}</h5>
          <h6>歌手：{{ singAlbum[0].ar[0].name }}</h6>
          <p>发行时间：{{ timeCon(singAlbumDe.publishTime) }}</p>
        </div>
      </div>
      <template v-if="singAlbumDe.briefDesc">
        <div class="det">简介： {{ singAlbumDe.briefDesc }}</div>
      </template>
      <template v-else>
        <div class="det">简介： {{ singAlbumDe.description }}</div>
      </template>

      <h4 class="slist">歌曲列表</h4>
      <ul>
        <SongListItem
          v-for="(item, index) in singAlbum"
          :key="index"
          :song-item="item"
          :is-show-quality="true"
          :index="index"
          @translate-currentid="$emit('translate-currentid', $event)"
        />
      </ul>
      <template v-if="albumComment">
        <h4 class="slist">最新评论</h4>
        <HotCom
          :hot-say="item"
          v-for="(item, index) in albumComment"
          :key="index"
        ></HotCom>
      </template>
    </template>
  </div>
</template>

<script>
import SongListItem from "@/components/SongListItem.vue";
import HotCom from "@/components/HotCom.vue";

export default {
  components: {
    SongListItem,
    HotCom
  },
  data() {
    return {
      singAlbum: [],
      singAlbumDe: [],
      albumComment: []
    };
  },
  methods: {
    // 获取专辑数据
    getAlbum(id) {
      this.axios
        .get("http://music.kele8.cn/album", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          //   window.console.log(reponse);
          ({ songs: this.singAlbum } = reponse.data);
        });
    },
    // 获取歌手简介
    getAlbumDe(id) {
      this.axios
        .get("http://music.kele8.cn/album", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          window.console.log(reponse);
          ({ album: this.singAlbumDe } = reponse.data);
        });
    },
    // 获取专辑评论
    getAlbumComment(id) {
      this.axios
        .get("http://music.kele8.cn/comment/album", {
          params: {
            id: id
          }
        })
        .then(reponse => {
          //   window.console.log(reponse.data);
          ({ comments: this.albumComment } = reponse.data);
          // ({hotComments:this.hotcom} = reponse.data);
        });
    },
    // 时间转换
    timeCon(n) {
      var now = new Date(n);
      var year = now.getFullYear(n);
      var month = now.getMonth(n) + 1;
      var day = now.getDate(n);
      return year + "-" + month + "-" + day;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getAlbum(to.query.id);
      vm.getAlbumDe(to.query.id);
      vm.getAlbumComment(to.query.id);
    });
  }
};
</script>

<style lang="less">
.album {
  .go-back {
    margin-left: 5px;
    font-size: 14px;
    color: #c62f2f;
  }
  .top {
    position: relative;
    display: flex;
    padding: 30px 10px 30px 15px;
    overflow: hidden;
    // filter: blur(20px);
    .bg {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      filter: blur(10px);
      background-position: center center;
      background-size: cover;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      background: rgba(0, 0, 0, 0.2);
      width: 100%;
      height: 100%;
      z-index: -1;
    }

    .fleft {
      // background: url("/album@2x.png") no-repeat right bottom;
      img {
        height: 126px;
        width: 126px;
      }
       b {
      color: #fff;
      display: inline-block;
      position: absolute;
      top: 42px;
      left: 15px;
      background: rgba(217, 48, 48, 0.8);
      line-height: 20px;
      padding: 0 8px;
      font-size: 12px;
      border-top-right-radius: 16px;
      border-bottom-right-radius: 16px;
    }
    }
    .fright {
      margin-left: 20px;
      color: #fefefe;

      h5 {
        font-size: 18px;
        line-height: 20px;
        padding: 5px 0;
      }
      h6 {
        font-size: 14px;
        line-height: 30px;
        margin-top: 20px;
        color: rgb(250, 244, 244);
      }
      p {
        font-size: 12px;
        line-height: 20px;
        color: rgb(250, 244, 244);
      }
    }
  }
  .det {
    color: #666;
    font-size: 14px;
    line-height: 20px;
    padding: 0 10px;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .slist {
    color: #666;
    font-size: 12px;
    line-height: 20px;
    background: #eeeff0;
    padding: 2px 10px;
  }
}
</style>
